export default __webpack_public_path__ + "static/media/businessplan_3@2x.1796002d.png";